import { render } from "./GeminiChatModal.vue?vue&type=template&id=4784721f&scoped=true"
import script from "./GeminiChatModal.vue?vue&type=script&lang=js"
export * from "./GeminiChatModal.vue?vue&type=script&lang=js"

import "./GeminiChatModal.vue?vue&type=style&index=0&id=4784721f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4784721f"]])

export default __exports__